import { connect } from 'react-redux'

import { getIsLoading } from 'data/src/redux/discoveryPublic/selectors'
import { getIsLoadingEarnPublic } from 'data/src/redux/discoveryEarnPublic/selectors'
import { doFetchRewardsEarnPublic } from 'data/src/redux/rewardsEarnPublic/dispatchers'
import { doFetchRewardsPublic } from 'data/src/redux/rewardsPublic/dispatchers'
import { getRewardsIds, getRewardById } from 'data/src/redux/rewardsPublic/selectors'
import { Reward } from 'data/src/redux/rewards/types'
import { RewardEarn } from 'data/src/redux/rewardsEarn/types'
import { convertRewardToCard } from 'data/src/utils/convertRewardToCard'
import { getRewardsIds as getRewardsIdsEarn, getRewardById as getRewardByIdEarn } from 'data/src/redux/rewardsEarnPublic/selectors'

import { DispatchFunction, RootState } from '../../../redux/types'
import { CardTypes, IntroCarouselBlockFields } from '../types'
import { IntroCarouselTileProps } from './IntroCarouselTile'
import { IntroCarouselBlock, IntroCarouselType } from './IntroCarouselBlock'

const MAX_NUMBER_ITEMS = 8

export const getSpendItemsPublicCarousel = (state: RootState): Reward[] => {
  const spendIds = getRewardsIds(state).slice(0, MAX_NUMBER_ITEMS)
  return spendIds.map((spendId) => getRewardById(state, spendId))
}

export const getEarnItemsPublicCarousel = (state: RootState): RewardEarn[] => {
  const earnIds = getRewardsIdsEarn(state).slice(0, MAX_NUMBER_ITEMS)
  return earnIds.map((earnId) => getRewardByIdEarn(state, earnId))
}

export const getItemsCarouselPublic = (state: RootState, type: CardTypes): IntroCarouselTileProps[] => {
  let items: (Reward | RewardEarn)[] = []
  switch (type) {
    case CardTypes.EARN:
      items = getEarnItemsPublicCarousel(state)
      break
    case CardTypes.SPEND:
      items = getSpendItemsPublicCarousel(state)
      break
  }
  return convertRewardToCard(items)
}

export const doFetchAllPublicCarousel = async (type: CardTypes, dispatch: DispatchFunction) => {
  switch (type) {
    case CardTypes.SPEND:
      // we limit the rewards fetch to 8
      // in the public Homepage to improve performance
      await doFetchRewardsPublic(8)(dispatch)
      break
    case CardTypes.EARN:
      await doFetchRewardsEarnPublic(8)(dispatch)
      break
  }
}

const mapStateToProps = (state: RootState, ownProps: { fields: IntroCarouselBlockFields }) => ({
  header: ownProps.fields.header?.fields,
  items: () => getItemsCarouselPublic(state, ownProps.fields.sliderContentType === 'Earn' ? CardTypes.EARN : CardTypes.SPEND),
  isLoading: ownProps.fields.sliderContentType === 'Earn' ? getIsLoadingEarnPublic(state) : getIsLoading(state),
  type: ownProps.fields.sliderContentType === 'Earn' ? IntroCarouselType.EARN : IntroCarouselType.REWARD,
})

const mapDispatchToProps = (dispatch: DispatchFunction, ownProps: { fields: IntroCarouselBlockFields }) => ({
  doGetItems: () => doFetchAllPublicCarousel(ownProps.fields.sliderContentType as CardTypes, dispatch),
})

export const IntroCarouselBlockPublicContainer = connect(mapStateToProps, mapDispatchToProps)(IntroCarouselBlock)
